import React from "react";
import PropTypes from "prop-types";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import ExclamationCircle from "./Icons/ExclamationCircle";
import styled from "styled-components";
import { rem } from "polished";
import UseWindowWidth from "./CustomHooks/UseWindowWidth";

const StyledIconContainer = styled.span`
  cursor: pointer;
  margin-left: ${rem("4px")};

  svg {
    margin-right: ${rem("16px")};

    ${({ theme }) => theme.tablet`
      margin-right: ${rem("0px")};
    `}
  }
`;

const StyledToolTip = styled(Tooltip)`
  opacity: 1 !important;

  .arrow {
    &:before {
      border-right-color: #ffffff;

      ${({ theme }) => theme.tablet`
        border-top-color: #FFFFFF;
      `}
    }
  }

  .tooltip-inner {
    font-family: ${({ theme }) => theme.secondaryFont};
    font-size: ${rem("14px")};
    padding: ${rem("18px")} ${rem("15px")};
    min-width: ${rem("250px")};
    color: #343638;
    text-align: left;
    background-color: #ffffff;
    box-shadow: 0px 0px 16px #0000001a;
  }
`;

const GuestbookTooltip = ({ message }) => {
  const WindowWidth = UseWindowWidth();

  return (
    <OverlayTrigger
      placement={WindowWidth > 768 ? "right" : "top"}
      delay={{ show: 250, hide: 1000 }}
      overlay={<StyledToolTip id="button-tooltip">{message}</StyledToolTip>}
    >
      <StyledIconContainer>
        <ExclamationCircle />
      </StyledIconContainer>
    </OverlayTrigger>
  );
};

GuestbookTooltip.propTypes = {
  message: PropTypes.string.isRequired,
};

export default GuestbookTooltip;
